import { render, staticRenderFns } from "./CategoryCreateEditModal.vue?vue&type=template&id=53cd0eaa&"
import script from "./CategoryCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports